import { getDatadogInstance } from '@cw-elements/analytics-provider';

// >>>> Please pay attention <<<
// when increment the `MonitoringErrorTypes` and `MonitoringErrorDomains` list,
// because that are used to categorize errors in the datadog monitoring and,
// used to create the dashboards and collect important metrics.
export type MonitoringErrorTypes =
  | 'AxiosError'
  | 'ValidationError'
  | 'UnknownError'
  | 'JSONParseError'
  | 'IndexedDBError';

// they are used in the datadog dashboard
type MonitoringErrorDomains =
  | 'Auth'
  | 'i18n'
  | 'AxiosInterceptor'
  | 'Purchase'
  | 'Invoice'
  | 'EletronicInvoice'
  | 'AccountsPayable'
  | 'ReportGeneralLedger'
  | 'Reports'
  | 'Item'
  | 'Stock'
  | 'ItemCategory'
  | 'Machinery'
  | 'Supplier'
  | 'BankAccount'
  | 'BalanceAi'
  | 'Dashboard'
  | 'Financial'
  | 'MaterialConsumption'
  | 'Migration'
  | 'ErrorBoundary'
  | 'Architecture'
  | 'CWElementsWrappers';

type RecordValuesType = string | boolean | number;
interface MonitoringContext {
  [key: string]:
    | Record<string, RecordValuesType>
    | string
    | boolean
    | number
    | undefined
    | string[];
  errorType?: MonitoringErrorTypes;
  crashScreen?: boolean;
  domain: MonitoringErrorDomains;
}

const handleUnknownError = (error: unknown) => {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === 'string') {
    return new Error(error);
  }

  try {
    return new Error(JSON.stringify(error) ?? String(error));
  } catch {
    return new Error(String(error));
  }
};

export const captureError = (error: unknown, context: MonitoringContext) => {
  const err = handleUnknownError(error);
  getDatadogInstance()?.addError(err, context);
};

export const setGlobalContext = (key: string, value: unknown) => {
  getDatadogInstance()?.setGlobalContextProperty(key, value);
};
